import { PostTypeEnum } from "@/generated/generated-hooks";

export const isCollectible = (postType: PostTypeEnum) => {
  return postType === PostTypeEnum.Nft || postType === PostTypeEnum.Eth721;
};

export const getCollectiblesPostType = () => {
  return Object.values(PostTypeEnum).filter((type) => isCollectible(type));
};

export const isCollectiblesOnly = (postTypes: PostTypeEnum[]) => {
  return postTypes.filter((type) => isCollectible(type)).length > 0;
};
